export default function getMaxElementsCount() {
    return $('#company-max-statements-count').val();
}
